import customFetch from '../../../utils/customFetch';

export const searchAMAFee = keyword => {
  return customFetch('/MAGService/SearchAMACode?keyword=' + keyword, {
    method: 'GET',
  });
};

export const searchAMACaculation = param => {
  return customFetch('/AMACalculationRule/GetAll', {
    method: 'POST',
    body: JSON.stringify(param),
  });
};

export const saveAMACalculationRule = param => {
  return customFetch('/MAGService/SaveAMACalculationRule', {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify(param),
  });
};

export const deleteAMA = id => {
  return customFetch('/MAGService/DeleteAMA', {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
    body: JSON.stringify({ id: id }),
  });
};

export const getStateList = id => {
  return customFetch('/MAGService/GetStates', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: {},
  });
};